module.exports = __webpack_public_path__ + "OS_Box_On.png?5a0fcfabf627405b62e9397d38c23426";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OS_Box_On.png
// module id = 67
// module chunks = 0